import type { Track } from '../sim/track';
import type { AiProfile } from './profiles';

/**
 * Vitesse cible : le MIN, sur l'horizon de freinage, de la vitesse permise par chaque virage à
 * venir. Pour un virage de courbure κ à la distance d : vitesse de passage = √(aLatMax/κ), et la
 * vitesse permise MAINTENANT = √(passage² + 2·brakeDecel·d) (on peut encore freiner d'ici là).
 * Plafonnée par speedCap. En ligne droite (κ≈0) → speedCap.
 */
export function targetSpeed(track: Track, idx: number, p: AiProfile): number {
  const s = track.samples;
  const n = s.length;
  let best = p.speedCap;
  let acc = 0;
  let i = idx;
  for (let guard = 0; guard < n && acc < p.brakeHorizon; guard++) {
    const k = s[i].curvature;
    if (k > 1e-4) {
      const corner = Math.sqrt(p.aLatMax / k);
      const allowed = Math.sqrt(corner * corner + 2 * p.brakeDecel * acc);
      if (allowed < best) best = allowed;
    }
    acc += s[i].segLen;
    i = (i + 1) % n;
  }
  return best;
}
